<template>
	<div v-show="!fadein || active">
		<div v-show="active" class="cover-layer an an-fadein" :class="{'an-fadeout': !show}" :style="{'z-index': zIndex}"></div>
		<div ref="content" class="c-dialog-wrapper an" :class="{'s-slide': !fadein, 'z-show': show, 'an-fadein': fadein, 'an-fadeout': fadein && !show}" :style="{'z-index': zIndex, 'margin-left': position.left, 'margin-top': position.top}">
			<div class="c-dialog an" :class="{'an-bounce': fadein, 'confirm': type == 'confirm'}" :style="{'width': compWidth, 'border-radius': fadein ? '10px' : '0'}">
				<div v-if="title !== false" class="c-dialog-head">
					<p>{{title}}</p>
				</div>
				<div v-if="closeButton" class="c-dialog-close flex-center" @click="close"><i class="tf tf-cross"></i></div>
				<div class="c-dialog-content" :class="{'flex-column': enableFlex}" :style="{'height': compHeight, 'overflow': fadein && compHeight == 'auto' ? '' : 'auto'}">
					<slot></slot>
				</div>
				<div v-if="button" class="c-dialog-button flex-center-cross flex-end-center">
					<slot v-if="$slots.button" name="button"></slot>
					<template v-else>
						<c-button size="m" @click="buttonHandle('resolve')">{{buttonName}}</c-button>
						<c-button v-if="cancelButton" color="black" size="m" hollow @click="buttonHandle('cancel')">取消</c-button>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			fadein: {
				type: Boolean,
				default: true
			},
			
			type:{
				type: String,
				default: ''
			},
			
			title: {
				type: [String, Boolean],
				default: ''
			},

			width: {
				type: [Number, String],
				default: 750
			},

			height: {
				type: [Number, String],
				default: 'auto'
			},

			closeButton: {
				type: Boolean,
				default: true
			},

			button: {
				type: Boolean,
				default: true
			},
			
			buttonName: {
				type: String,
				default: '确定'
			},

			cancelButton: {
				type: Boolean,
				default: true
			},
			
			enableFlex: Boolean
		},

		data() {
			return {
				position: {},
				zIndex: 0,
				active: false,
				show: false,
				actualHeight: 0
			}
		},

		computed: {
			compWidth() {
				if (this.width == parseInt(this.width)) {
					return `${parseInt(this.width)}px`;
				}
				return this.width;
			},

			compHeight() {
				if (this.actualHeight) {
					return this.actualHeight + 'px';
				}
				
				if (this.height == 'auto') {
					return 'auto';
				} else if (this.height.toString().includes('%')) {
					return `${document.body.offsetHeight * parseInt(this.height) / 100}px`;
				} else {
					return `${parseInt(this.height)}px`;
				}
			}
		},

		methods: {
			open() {
				if (this.fadein) {
					setTimeout(() => {
						let height = this.$refs.content.clientHeight;
						if (height > window.innerHeight - 222) {
							this.actualHeight = window.innerHeight - 222;
							height = this.actualHeight + 122;
						} else {
							this.actualHeight = 0;
						}
						
						this.position = {
							left: -Math.ceil(this.$refs.content.clientWidth / 2) + 'px',
							top: -Math.ceil(height / 2) + 'px'
						}
					});
				}
				this.zIndex = window.cDialogZIndex++;
				this.show = true;
				this.active = true;
			},

			close() {
				this.show = false;
				setTimeout(() => {
					this.active = false;
				}, 250);
				this.$emit('close');
			},

			buttonHandle(state) {
				if (!this._await) {
					this._await = true;
					setTimeout(() => {
						this._await = false;
					}, 200);
				} else {
					return;
				}
				let stop = false;
				this.$emit(state, () => {
					stop = true;
				}, () => {
					this.close();
				});
				!stop && this.close();
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-dialog {
		width: 750px;
		border-radius: 10px;
		background: #fff;
		
		&.confirm {
			.c-dialog-head {
				line-height: 44px;
				border-bottom: none;
				
				p {
					font-size: 15px;
					text-indent: 18px;
				}
			}
			
			.c-dialog-button {
				height: 54px;
				padding: 0 14px;
				
				button {
					min-width: 72px;
				}
			}
		}
		
		&-wrapper {
			position: fixed;
			left: 50%;
			top: 50%;
			z-index: 102;
			
			&.s-slide {
				left: auto;
				right: 0;
				top: 0;
				bottom: 0;
				transform: translate(100%, 0);
				transition: transform .4s ease;
				
				&.z-show {
					transform: translate(0, 0);
				}
				
				.c-dialog {
					display: flex;
					flex-direction: column;
					height: 100%;
					
					&-content {
						flex-grow: 1;
						height: auto;
					}
				}
			}
		}

		&-head {
			line-height: 60px;
			border-bottom: 1px solid #f0f0f0;
			
			p {
				font-size: 18px;
				font-weight: bold;
				text-indent: 30px;
			}
		}

		&-close {
			z-index: 1;
			position: absolute;
			right: 0;
			top: 10px;
			width: 40px;
			height: 40px;
			margin-right: 10px;
			font-size: 18px;
			color: #999;
			cursor: pointer;
			
			&:hover{
				color: #000;
			}
		}

		&-button {
			height: 60px;
			min-height: 60px;
			border-top: 1px solid #EEEEEE;
			padding: 0 20px;
			
			button {
				padding: 0 20px;
				margin-left: 12px;
			}
		}
	}
</style>
